export default {
  install(Vue) {
    Vue.mixin({
      beforeCreate() {
        if (this.$options.bus) {
          this.$bus = typeof this.$options.bus === 'function'
            ? this.$options.bus()
            : this.$options.bus;
        } else if (this.$options.parent && this.$options.parent.$bus) {
          this.$bus = this.$options.parent.$bus;
        }
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/bus.js